import './collaborator-invite-modal.style.sass';
import template from './collaborator-invite-modal.tpl.pug';

class CollaboratorInviteModalController {
    $onInit() {
        this.email = null;
        this.emails = this.emails || [];
    }

    invite() {
        return this.onClose({
            data: this.email
        });
    }

    dismiss() {
        return this.onDismiss();
    }
}

export default {
    selector: 'dbACollaboratorInviteModal',
    template: template(),
    controller: CollaboratorInviteModalController,
    bindings: {
        emails: '<',
        user: '<',
        onDismiss: '&',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/collaborator-invite-modal/collaborator-invite-modal.cmpt.js